import { react } from "uikit";
import { Dispatch } from "react";

import { PaymentCurrency } from "../../../../../../../../services/PaymentSystem";

import MonobankPaymentsCurrency from ".";

interface Context {
	value: MonobankPaymentsCurrency.Value;
	setError: Dispatch<boolean>;
}

export default class Controller extends react.ControllerBase<Context> {
	validate() {
		const isValid =
			this.context?.value.monobankCurrency !== PaymentCurrency.NULL;

		if (!isValid) {
			this.context?.setError(true);
			return isValid;
		}
		this.context?.setError(false);
		return isValid;
	}
}
